var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyTeams(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 93,
    viewBox: "0 0 132 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipEmptyTeams)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M98.973 75.9627C96.3244 62.9405 84.8649 53.1196 71.0811 53.1196C62.8649 53.1196 55.4054 56.6464 50.2162 62.2351C48.1622 64.4055 46.4865 66.9557 45.2433 69.7229L45.2973 69.7771C44.3244 71.7847 43.6217 73.9551 43.1892 76.1797C42.5946 79.1639 44.9189 81.8769 47.8919 81.8769H79.946L80.2703 81.6599H94.2703C97.2433 81.7141 99.5676 78.9469 98.973 75.9627Z",
    fill: "#5A4BF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.1351 44.6552C75.3448 44.6552 82 37.9747 82 29.734C82 21.4932 75.3448 14.8127 67.1351 14.8127C58.9255 14.8127 52.2703 21.4932 52.2703 29.734C52.2703 37.9747 58.9255 44.6552 67.1351 44.6552Z",
    stroke: "#5A4BF8",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.973 67.2812C91.7297 64.514 90 62.0181 88 59.7935C82.8108 54.2048 75.4054 50.6779 67.1351 50.6779C53.3513 50.6779 41.8919 60.4988 39.2432 73.521C38.6486 76.5052 40.973 79.2182 43.9459 79.2182H92.973",
    stroke: "#5A4BF8",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M71.027 47.2596C79.2367 47.2596 85.8919 40.5792 85.8919 32.3384C85.8919 24.0976 79.2367 17.4171 71.027 17.4171C62.8174 17.4171 56.1622 24.0976 56.1622 32.3384C56.1622 40.5792 62.8174 47.2596 71.027 47.2596Z",
    fill: "#5A4BF8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M37.6757 44.9265C41.9148 44.9265 45.3514 41.4769 45.3514 37.2217C45.3514 32.9665 41.9148 29.5169 37.6757 29.5169C33.4365 29.5169 30 32.9665 30 37.2217C30 41.4769 33.4365 44.9265 37.6757 44.9265Z",
    fill: "#5A4BF8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M44.2162 61.4755C42.8649 54.7474 36.919 49.7013 29.8379 49.7013C25.5676 49.7013 21.7298 51.4918 19.0811 54.4218C18.0541 55.5613 17.1352 56.8635 16.4865 58.2742H16.5406C16.0541 59.3051 15.6757 60.4446 15.4595 61.584C15.1352 63.1033 16.3244 64.514 17.8919 64.514H34.4325L34.5946 64.4055H41.8379C43.3514 64.4597 44.5406 62.9948 44.2162 61.4755Z",
    fill: "#5A4BF8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M102.757 44.9265C106.996 44.9265 110.432 41.4769 110.432 37.2217C110.432 32.9665 106.996 29.5169 102.757 29.5169C98.5176 29.5169 95.0811 32.9665 95.0811 37.2217C95.0811 41.4769 98.5176 44.9265 102.757 44.9265Z",
    fill: "#5A4BF8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M122.865 60.6074C121.514 53.8792 115.568 48.8331 108.432 48.8331C104.162 48.8331 100.324 50.6237 97.6757 53.5537C96.6487 54.6931 95.7298 55.9953 95.0811 57.4061H95.1352C94.6487 58.437 94.2703 59.5764 94.0541 60.7159C93.7298 62.2351 94.919 63.6459 96.4865 63.6459H113.027L113.189 63.5373H120.432C122 63.5916 123.189 62.1266 122.865 60.6074Z",
    fill: "#5A4BF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4054 44.818C40.3312 44.818 44.3244 40.8097 44.3244 35.8652C44.3244 30.9208 40.3312 26.9125 35.4054 26.9125C30.4796 26.9125 26.4865 30.9208 26.4865 35.8652C26.4865 40.8097 30.4796 44.818 35.4054 44.818Z",
    stroke: "#5A4BF8",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5676 67.0099H21.4595C19.6216 67.0099 18.2703 65.3279 18.5946 63.5916C20.1622 55.724 27.0811 49.8641 35.4054 49.8641C39.5135 49.8641 43.2973 51.329 46.2162 53.7164",
    stroke: "#5A4BF8",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.7297 45.6861C104.655 45.6861 108.649 41.6778 108.649 36.7334C108.649 31.7889 104.655 27.7806 99.7297 27.7806C94.8039 27.7806 90.8108 31.7889 90.8108 36.7334C90.8108 41.6778 94.8039 45.6861 99.7297 45.6861Z",
    stroke: "#5A4BF8",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.108 67.878H113.622C115.459 67.878 116.811 66.196 116.486 64.4597C114.919 56.5922 108 50.7322 99.6757 50.7322C95.5676 50.7322 91.7838 52.1972 88.8649 54.5846",
    stroke: "#5A4BF8",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.7568 8.03034C94.6973 8.03034 96.2703 6.45132 96.2703 4.5035C96.2703 2.55568 94.6973 0.976662 92.7568 0.976662C90.8163 0.976662 89.2433 2.55568 89.2433 4.5035C89.2433 6.45132 90.8163 8.03034 92.7568 8.03034Z",
    stroke: "#ADABFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3784 15.4638C41.8114 15.4638 42.973 14.2978 42.973 12.8594C42.973 11.421 41.8114 10.255 40.3784 10.255C38.9455 10.255 37.7838 11.421 37.7838 12.8594C37.7838 14.2978 38.9455 15.4638 40.3784 15.4638Z",
    stroke: "#ADABFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91895 10.4177L14.1622 15.6809",
    stroke: "#ADABFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91895 15.6809L14.1622 10.4177",
    stroke: "#ADABFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.8919 40.1517L1.02704 49.213C1.02704 49.43 1.1892 49.5385 1.40542 49.4842L9.67569 45.6861C9.83785 45.5776 9.8919 45.3606 9.72974 45.252L2.32434 39.9347C2.16217 39.8261 1.94596 39.9347 1.8919 40.1517Z",
    stroke: "#ADABFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.757 42.0508H121.676C121.459 42.0508 121.351 42.2678 121.459 42.4306L126 50.3524C126.108 50.5152 126.378 50.5152 126.432 50.3524L130.973 42.4306C131.081 42.2678 130.973 42.0508 130.757 42.0508Z",
    stroke: "#ADABFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipEmptyTeams"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 132,
    height: 93,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyTeams);
export default __webpack_public_path__ + "static/media/EmptyTeams.4599fb68fd4963c7f2ec4717ab7b76cd.svg";
export { ForwardRef as ReactComponent };